import { Injectable } from '@angular/core';
import { baseURL, configJSON } from '../../appConfig';
import { HttpClient } from '@angular/common/http';
import  config from '../../../assets/config.json';
import { ConnectionListModel, ConnectionList } from '../../common/models';
import { Observable, Subject } from 'rxjs';
import { LocalStorageModelType, ResponseMessageType } from '../../common/enum';
import { AuthService } from '../auth.service';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ConnectionListService {
  public connectionURL: URL = null;
  public connectionGuid = '';
  connectionServiceSubject = new Subject<any>();
  public userConnectionList: ConnectionList[];
  public isConnectionDisable = false;
  constructor(private http: HttpClient, private authService: AuthService, private localStorageService: LocalStorageService) {
  }
  getUpdatedRequestURL(requestURL: URL) {
    const requestURLPathname = requestURL.pathname.toLocaleLowerCase();
    const objBaseURL = new URL(baseURL);
    let evaluatedURL = objBaseURL.origin;

    if (
      (requestURLPathname.includes(config.getAccessCode.toLocaleLowerCase())) ||
      (requestURLPathname.includes(config.validateAccessCode.toLocaleLowerCase()) ||
      (requestURLPathname.includes(config.refreshToken.toLocaleLowerCase())) ||
      (requestURLPathname.includes(config.getDownloadDocument.toLocaleLowerCase())) ||
      (requestURLPathname.includes(config.getEmailDocument.toLocaleLowerCase())) ||
      (requestURLPathname.includes(config.getLibraryByConnection.toLocaleLowerCase())) ||
      (requestURLPathname.includes(config.getUserConnection.toLocaleLowerCase()))
      )
    ) {
      evaluatedURL = objBaseURL.origin;
    } else {
      evaluatedURL = this.connectionURL ?  this.connectionURL.origin : evaluatedURL;

    }
    return evaluatedURL + requestURL.pathname + requestURL.search;
  }

  public setConnectionList() {
      this.connectionURL = null;
      const user = this.authService.getClientUserData();
      if (!user || !user.userGuid) {
        return;
      }
      this.http.post<ConnectionListModel>(
      configJSON.getUserConnection,
      {},
      {withCredentials: true}
    ).subscribe((result: ConnectionListModel) => {
      if ((result && result.message === ResponseMessageType.SUCCESS) && (result.data && result.data.length)) {
         this.connectionURL = new URL(result.data[0].dataCenterUrl);
        this.connectionGuid = this.localStorageService.getLocalStorage(LocalStorageModelType.CONNECTION);
        if (!this.connectionGuid) {
          this.connectionGuid = result.data[0].connectionGuid;
        }
         this.userConnectionList = result.data;
         this.setSubject(this.connectionGuid );
      } else {
        // Logout the user if connection is not available
        this.authService.logout();
      }
     }, (error) => {
       // Logout the user if any error occured while getting the connections
       this.authService.logout();
     });
  }

  setSubject(connectionGuid: string) {
    this.connectionGuid = connectionGuid;
    this.userConnectionList.map((connection) => {
    if (connection.connectionGuid === connectionGuid) {
      this.connectionURL = new URL(connection.dataCenterUrl);
    }
   });
    this.connectionServiceSubject.next(connectionGuid);
  }

  getSubject(): Observable<any> {
    return this.connectionServiceSubject.asObservable();
  }

  public getConnectionDatacenterURL(): String {
      return this.connectionURL.href.replace(/\/$/, '');;
  }
}
